import React from 'react';
import { Flame, Instagram, Twitter, Facebook, Mail } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-obsidian border-t border-white/5 pt-16 pb-8 relative" data-id="element-25">
      {/* Rose Divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 text-crimson opacity-50" data-id="element-26">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-27">
          <circle cx="12" cy="12" r="6" data-id="element-28" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-30">
          <div className="col-span-1 md:col-span-2" data-id="element-31">
            <div className="flex items-center gap-2 mb-6" data-id="element-32">
              <Flame className="w-6 h-6 text-amber-glow" data-id="element-33" />
              <span className="font-heading text-2xl font-bold text-parchment tracking-widest" data-id="element-34">
                Ravenhold
              </span>
            </div>
            <p className="font-body text-bone/60 max-w-sm mb-6" data-id="element-35">
              A sanctuary for the dark, the gothic, and the macabre. We build
              the shadows where you find your light.
            </p>
            <div className="flex gap-4" data-id="element-36">
              {[Instagram, Twitter, Facebook, Mail].map((Icon, i) => <a key={i} href="#" className="text-bone/40 hover:text-amber-glow transition-colors" data-id="element-37">
                  <Icon className="w-5 h-5" data-id="element-38" />
                </a>)}
            </div>
          </div>

          <div data-id="element-39">
            <h4 className="font-heading text-parchment font-semibold mb-6 tracking-wider" data-id="element-40">
              Explore
            </h4>
            <ul className="space-y-3 font-body text-bone/60" data-id="element-41">
              <li data-id="element-42">
                <a href="#manifesto" className="hover:text-amber-glow transition-colors" data-id="element-43">
                  Manifesto
                </a>
              </li>
              <li data-id="element-44">
                <a href="#features" className="hover:text-amber-glow transition-colors" data-id="element-45">
                  Offerings
                </a>
              </li>
              <li data-id="element-46">
                <a href="#pricing" className="hover:text-amber-glow transition-colors" data-id="element-47">
                  Membership
                </a>
              </li>
              <li data-id="element-48">
                <a href="#" className="hover:text-amber-glow transition-colors" data-id="element-49">
                  The Circle
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-50">
            <h4 className="font-heading text-parchment font-semibold mb-6 tracking-wider" data-id="element-51">
              Location
            </h4>
            <address className="font-body text-bone/60 not-italic space-y-2" data-id="element-52">
              <p data-id="element-53">Ravenhold HQ</p>
              <p data-id="element-54">Limassol, Cyprus</p>
              <p className="text-xs text-bone/30 mt-4" data-id="element-55">By appointment only</p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 text-center font-body text-sm text-bone/30" data-id="element-56">
          <p data-id="element-57">&copy; 2026 Ravenhold. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}